<div class="container{{ isModal || fullWidth() ? '-fluid' : '' }} d-print-none">
  <div class="row">
    <div class="col p-0 d-lg-flex align-items-center justify-content-between w-100">
      <div class="d-flex gap-3">
        @if (showBack()) {
          <app-back-button (click)="back()"></app-back-button>
        }
        @if (navIds.previousId) {
          <a (click)="previous()"><i class="fa fa-angle-double-left"></i>&nbsp;<span i18n>Previous</span></a>
        }
        @if (navIds.nextId) {
          <a (click)="next()"><span i18n>Next</span>&nbsp;<i class="fa fa-angle-double-right"></i></a>
        }
      </div>
      <h2 class="text-nowrap">
        @if (header()) {
          <span>{{ header() }}</span>
        }
        @if (name() && !header()) {
          <span>
            {{
              menuService.isReadOnly || !this.showSave() ? '' : isNewModel(model$() | async) ? createHeader : editHeader
            }}
            {{ name() }}
          </span>
        }
      </h2>
    </div>
  </div>
  @if (
    summaryItems() || showSaveButton || showAdditionalButtons(model$() | async) || showCopyButton(model$() | async)
  ) {
    <div class="row">
      <div class="col p-0 d-lg-flex align-items-center justify-content-between w-100" [class.mb-3]="!isModal">
        <app-summary [model$]="model$()" [summaryItems]="summaryItems()"></app-summary>
        <div class="d-flex mt-2 mt-lg-0">
          @if (showAdditionalButtons(model$() | async)) {
            @if (model$() | async; as model) {
              @for (additionalButton of additionalButtons(); track $index) {
                @if (isDropdown(additionalButton)) {
                  <div class="btn-group" ngbDropdown placement="bottom">
                    <button
                      type="button"
                      class="btn btn-info"
                      (click)="onDropdownItemClick(dropdownItems(additionalButton)[0], model)"
                    >
                      @if (dropdownIconClass(additionalButton)) {
                        <i class="{{ dropdownIconClass(additionalButton) }} me-2"></i>
                      }
                      {{ dropdownLabel(additionalButton) }}
                    </button>
                    <button
                      i18n-aria-label
                      type="button"
                      class="btn btn-info dropdown-toggle dropdown-toggle-split"
                      ngbDropdownToggle
                      aria-label="Toggle dropdown"
                    ></button>
                    <div ngbDropdownMenu class="dropdown-menu">
                      @for (item of dropdownMenuItems(additionalButton); track item.text) {
                        <button
                          ngbDropdownItem
                          type="button"
                          class="dropdown-item d-flex align-items-center"
                          (click)="onDropdownItemClick(item, model)"
                        >
                          @if (item.iconClass) {
                            <i class="{{ item.iconClass }} me-2"></i>
                          }
                          {{ item.text }}
                        </button>
                      }
                    </div>
                  </div>
                } @else {
                  <button
                    type="button"
                    class="btn btn-{{ additionalButton.cssClass ?? 'info' }} d-flex align-items-center"
                    [disabled]="additionalButton.disabled"
                    [title]="additionalButton.disabled ? (additionalButton.disabledTitle ?? '') : ''"
                    (click)="guarded(additionalButton.click)"
                  >
                    @if (additionalButton.image) {
                      <img [src]="additionalButton.image" height="16" width="16" alt="" />
                    }
                    @if (additionalButton.icon) {
                      <i class="fa fa-{{ additionalButton.icon }}"></i>
                    }
                    <span>{{ additionalButton.text }}</span>
                  </button>
                }
              }
            }
          }
          @if (showCopyButton(model$() | async)) {
            <button type="button" class="btn btn-success" [disabled]="!enableCopyButton()" (click)="copy()">
              <i class="fa fa-copy"></i> {{ copyButtonText() }}
            </button>
          }
          @if (showSaveButton) {
            <button type="button" class="btn btn-primary" (click)="save()">
              <i class="fa fa-save"></i> {{ saveButtonText() }}
            </button>
          }
        </div>
      </div>
    </div>
  }
</div>
@if (mobile()) {
  <hr />
}
